/* eslint-disable @typescript-eslint/no-unused-vars */

import { StoreOption, useStore, withContextStore } from '@doltech/core/lib/entity/store';
import { startDoDictation } from '@doltech/modules/lib/dictation/api/dictation';
import { saveUserDictationProgress } from '@doltech/modules/lib/dictation/api/userDictation';
import {
  DoDictationStore,
  DoDictationStoreInstance,
} from '@doltech/modules/lib/dictation/models/do-dictation.store';
import dynamic from 'next/dynamic';

import { useGetAuthInfo } from '@doltech/core/lib/auth/withGlobalUserAuthInfo';
import { DUAL_TOGGLE } from '@doltech/domains/dictation/shared/constant';
import { withUserActivityTracking } from '@doltech/modules/lib/landing/hocs/withUserActivityTracking';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { useUserAuthentication } from '@doltech/ui/lib/figma/Auth/hocs/withUserAuthentication';
import {
  LandingLayout,
  LandingLayoutContent,
  LandingLayoutHeader,
} from '@doltech/ui/lib/figma/Layout/Landing/LandingLayout';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { withControlledAudioPlayInBackground } from '@doltech/ui/lib/hooks/controlled-audio-play-in-background.store';
import { withControlledVideo } from '@doltech/ui/lib/hooks/controlled-video.store';
import {
  useDolPremiumStore,
  withDolPremiumStore,
} from '@doltech/ui/lib/hooks/dolPremium/withDolPremium';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { withAudioInputDevices } from '@doltech/ui/lib/voice-recognition/hocs/withAudioInputDevices';
import { withPronunciationAssessment } from '@doltech/ui/lib/voice-recognition/hocs/withPronunciationAssessment';
import { compose } from '@doltech/utils/lib/compose';
import { ActivityTypeEnum, DictationTypeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import { onAction } from 'mobx-state-tree';
import * as React from 'react';
import { useMutation } from 'react-query';
import styled from 'styled-components';

const DoDictationVideoBeforeLogin = dynamic(() =>
  import('@doltech/modules/lib/dictation/templates/video/DoDictationVideoBeforeLogin').then(
    (m) => m.DoDictationVideoBeforeLogin
  )
);

const DoDictationVideoAfterLogin = dynamic(() =>
  import('@doltech/modules/lib/dictation/templates/video/DoDictationVideoAfterLogin').then(
    (m) => m.DoDictationVideoAfterLogin
  )
);

const DoDictationAudioBeforeLogin = dynamic(() =>
  import('@doltech/modules/lib/dictation/templates/audio/DoDictationAudioBeforeLogin').then(
    (m) => m.DoDictationAudioBeforeLogin
  )
);

const DoDictationAudioAfterLogin = dynamic(() =>
  import('@doltech/modules/lib/dictation/templates/audio/DoDictationAudioAfterLogin').then(
    (m) => m.DoDictationAudioAfterLogin
  )
);

const CONTENT_WIDTH = 1080;

interface DoDictationTemplatePageProps
  extends React.HTMLAttributes<HTMLDivElement>,
    DynamicPageProps {}

interface DoDictationTemplatePageUIProps extends DoDictationTemplatePageProps {
  isLogged: boolean;
  startData: any;
}

// const DoDictationTemplatePageUI = observer((props: DoDictationTemplatePageUIProps) => {
//   const { isLogged, startData, data, seoData, internalPageLink } = props;
//   const { landingDictation } = data;
//   const router = useRouter();
//   const { dictation } = useStore<{ dictation: DoDictationStoreInstance }>();
//   const { isDesktop, isMobile } = useDeviceDetect();

//   const [savingProgressBeforeBack, setSaveProgressBeforeBack] = React.useState(false);
//   const userDictationQuery = useQuery(
//     ['user-dictation', startData?.id],
//     ({ queryKey }) => getUserDictationById(queryKey[1]),
//     {
//       enabled: Boolean(startData?.id),
//       onSuccess: (res) => {
//         dictation.init(res.data.dictation, res.data.userAnswers);
//         dictation.setTimeTakenInSeconds(res.data?.timeTakenInSeconds || 0);
//       },
//     }
//   );

//   const userDictationOverviewQuery = useQuery(
//     ['dictation-overview', data.dictation.id, isLogged],
//     ({ queryKey }) => getUserDictationOverview(queryKey[1]),
//     {
//       enabled: Boolean(data?.dictation?.id),
//       onSuccess: (res) => {
//         dictation.setNoOfUsersCompleted(res?.data?.content?.[0]?.noOfUsersCompleted);
//         dictation.setTotalTimeTakenInSeconds(res?.data?.content?.[0]?.timeTakenInSeconds); // all dictations (completed + in progress)
//       },
//       refetchOnWindowFocus: false,
//       refetchIntervalInBackground: false,
//       refetchInterval: false,
//       refetchOnMount: true,
//       retry: false,
//     }
//   );

//   const saveProgress = useMutation(() => {
//     if (userDictationQuery?.data?.data?.id) {
//       return saveUserDictationProgress(userDictationQuery.data.data.id, dictation.preparePayload());
//     }
//     return null;
//   });

//   const submit = useMutation(() => {
//     return submitUserDictation(userDictationQuery.data.data.id, dictation.preparePayload());
//   });

//   const handleSaveProgress = (_, cb = noop) => {
//     const activeTimeInSeconds = Math.round(getTotalActiveTime() / 1000);

//     dictation.increaseTimeTakenInSeconds(activeTimeInSeconds);
//     saveProgress.mutate(undefined, {
//       onSuccess: () => {
//         dictation.setTotalTimeTakenInSeconds(
//           dictation.totalTimeTakenInSeconds + activeTimeInSeconds
//         );
//         cb();
//       },
//       onError: () => {
//         setSaveProgressBeforeBack(false);
//       },
//     });
//   };

//   const { reset, getTotalActiveTime } = useIdleTimer({
//     timeout: FIVE_MINUTES,
//     onAction: handleSaveProgress,
//     onActive: handleSaveProgress,
//     onIdle: handleSaveProgress,
//     throttle: ONE_MINUTE,
//     eventsThrottle: ONE_MINUTE,
//   });

//   // ssr
//   if (!dictation.initialized) {
//     dictation.init(data.dictation);
//     reset();
//   }

//   return (
//     <Spin
//       spinning={userDictationOverviewQuery.isLoading || savingProgressBeforeBack}
//       tip={savingProgressBeforeBack ? 'Saving your progress...' : 'Preparing data...'}
//     >
//       <LandingLayoutWithSEOHeaderContext.Provider
//         value={{
//           children: <span />,
//           socials: [],
//           testId: null,
//           testType: null,
//           pageData: [],
//           seoData: data.page,
//         }}
//       >
//         <DoDictationContext.Provider
//           value={{
//             submitting: submit.isLoading,
//             submit: () => {
//               const activeTimeInSeconds = Math.round(getTotalActiveTime() / 1000);
//               dictation.increaseTimeTakenInSeconds(activeTimeInSeconds);

//               submit.mutate(undefined, {
//                 onSuccess: () => {
//                   router.replace(landingDictation.url);
//                 },
//               });
//             },
//           }}
//         >
//           <StyledLandingLayout defaultSidebarOpen={false} style={{ width: '100%' }}>
//             <Main showBanner={false}>
//               <LandingLayoutHeader.BackBtn
//                 hasLabel={!isMobile}
//                 onClick={() => {
//                   setSaveProgressBeforeBack(true);
//                   handleSaveProgress(undefined, () => {
//                     router.replace(
//                       internalPageLink.staticPageLink?.[PageTypeEnum.LANDING_DICTATION]?.url
//                     );
//                   });
//                 }}
//               />
//               {isMobile ? (
//                 <Typography.Text variant="medium/16" style={{ marginLeft: 14 }}>
//                   {dictation.name}
//                 </Typography.Text>
//               ) : (
//                 <LandingLayoutHeader.BasicInfo thumbnail={dictation.cover} title={dictation.name} />
//               )}
//               <ObservedHeaderAction pageId={seoData.id} isMobile={isMobile} seoUrl={seoData.url} />
//             </Main>

//             <StyledLandingLayoutContent id="do-dictation-landing-layout-content">
//               <LandingLayoutContent.LeftOverlaySidebar displayAsSideBar disabled={isDesktop}>
//                 <LandingSideBar disableHeadTag />
//               </LandingLayoutContent.LeftOverlaySidebar>

//               <StyledSectionMiddle>
//                 <ObservedDoDictation />
//               </StyledSectionMiddle>
//             </StyledLandingLayoutContent>
//             <Footer>
//               <ObservedDictationNavigator />
//             </Footer>
//           </StyledLandingLayout>
//         </DoDictationContext.Provider>
//       </LandingLayoutWithSEOHeaderContext.Provider>
//     </Spin>
//   );
// });

const DoDictationTemplatePageBase = (props: DoDictationTemplatePageProps) => {
  const { data, internalPageLink } = props;
  const { forceLoginToProceedAction } = useUserAuthentication();
  const premiumStore = useDolPremiumStore();
  const { refetch, authManager } = useGetAuthInfo();
  const startData = React.useRef(null);
  const { dictation: dictationStore } = useStore<{ dictation: DoDictationStoreInstance }>();

  const startMutate = useMutation(async (dictationId: string) => {
    const res = await startDoDictation(dictationId);
    return res.data;
  });

  const saveProgress = useMutation((userDictationId: string) => {
    return saveUserDictationProgress(userDictationId, dictationStore.preparePayload());
  });

  // const startDictation = React.useCallback(async () => {
  //   const userDictation = await startMutate.mutateAsync(data.dictation.id);
  //   if (userDictation?.id) {
  //     dictationStore.init(data.dictation, dictationStore.preparePayload().userAnswers);
  //     dictationStore.setTimeTakenInSeconds(data?.timeTakenInSeconds || 0);
  //   }

  //   return userDictation;
  // }, [data.dictation, data?.timeTakenInSeconds, dictationStore, startMutate]);

  const handleSaveProgress = React.useCallback(
    (userDictationId) => {
      saveProgress.mutate(userDictationId, {
        onSuccess: () => {
          dictationStore.setTotalTimeTakenInSeconds(dictationStore.totalTimeTakenInSeconds);
        },
      });
    },
    [dictationStore, saveProgress]
  );

  const handleCheck = React.useCallback(() => {
    const isLoggedIn = authManager.isLoggedIn();

    if (!isLoggedIn) {
      forceLoginToProceedAction(
        async () => {
          refetch();
        },
        {
          title:
            '<span>Để <span class="red">kiểm tra bài chép</span> bạn cần phải đăng ký tài khoản!</span>',
          defaultBack: internalPageLink.staticPageLink.LANDING_DICTATION.url,
        }
      );
      return;
    }

    if (dictationStore.currentSentence?.dualToggle === DUAL_TOGGLE.SUGGEST_TEXT) {
      dictationStore.currentSentence?.check?.(true);
    } else {
      dictationStore.currentSentence?.freeTextCheck?.();
    }

    if (startData?.current?.id) {
      handleSaveProgress(startData?.current?.id);
    }
  }, [
    authManager,
    premiumStore.isExpired,
    dictationStore.currentSentence,
    forceLoginToProceedAction,
    internalPageLink.staticPageLink.LANDING_DICTATION.url,
    refetch,
    handleSaveProgress,
  ]);

  React.useEffect(() => {
    const isLoggedIn = authManager.isLoggedIn();

    if (isLoggedIn && !startData.current && !startMutate.isLoading) {
      startMutate.mutate(data.dictation.id, {
        onSuccess: (resData) => {
          startData.current = resData;
        },
      });
    }
  }, [authManager, data.dictation.id, startMutate]);

  React.useEffect(() => {
    const disposer = onAction(dictationStore, async (call) => {
      if (call.name === 'checkAnswer') {
        await handleCheck();
      }
    });
    return () => {
      disposer();
    };
  }, [dictationStore, internalPageLink.staticPageLink.LANDING_DICTATION.url]);

  if (authManager.isLoggedIn() && startData.current) {
    return data.dictation.type === DictationTypeEnum.VIDEO ? (
      <DoDictationVideoAfterLogin {...props} startData={startData.current} />
    ) : (
      <DoDictationAudioAfterLogin {...props} startData={startData.current} />
    );
  }

  return data.dictation.type === DictationTypeEnum.VIDEO ? (
    <DoDictationVideoBeforeLogin {...props} />
  ) : (
    <DoDictationAudioBeforeLogin {...props} />
  );
};

const StyledLandingLayout = styled(LandingLayout)`
  min-height: unset;
`;

const StyledLandingLayoutContent = styled(LandingLayoutContent)`
  position: fixed;
  top: 65px;
  height: calc(100% - 130px);
  width: 100%;
  overflow: auto;
  display: block;
  background-color: ${colorsV2.black5};
  padding-bottom: 0;
`;

const StyledSectionMiddle = styled(LandingLayoutContent.SectionMiddle)`
  overflow-x: unset !important;
  overflow-y: unset !important;
  max-width: 100% !important;
  padding-top: unset !important;
`;

const Main = styled(LandingLayoutHeader)`
  padding: 10px calc((50% - ${CONTENT_WIDTH / 2}px));
  min-height: 68px;
  @media ${deviceBreakpoints.mobile} {
    padding: 10px 16px;
  }
  @media ${deviceBreakpoints.tablet} {
    padding: 10px 28px;
  }

  .basic-info-container {
    display: flex;
    flex-direction: row;
    margin-left: 24px;
    align-items: center;

    .title-container {
      display: flex;
      flex-direction: column;
      margin-left: 12px;
    }
  }

  .actions-container {
    .action-wrapper {
      @media ${deviceBreakpoints.allExceptMobile} {
        margin-left: 48px;
      }
    }

    .action-wrapper-not-login {
      @media ${deviceBreakpoints.allExceptMobile} {
        margin-left: 190px;
      }
    }
  }

  .social-button {
    height: 24px;
  }
`;

const Footer = styled.div`
  height: 64px;
  width: 100%;
  background-color: ${colorsV2.white100};
  padding: 12px calc((100% - ${CONTENT_WIDTH}px) / 2);
  position: fixed;
  bottom: 0;
  box-shadow: 0 -10px 20px ${colorsV2.blackShadow4}, 0 -2px 6px ${colorsV2.blackShadow4},
    0 0 1px ${colorsV2.blackShadow4};
  z-index: 1;
  @media ${deviceBreakpoints.mobile} {
    padding: 12px 16px;
  }
  @media ${deviceBreakpoints.tablet} {
    padding: 12px 28px;
  }
`;

export const DoDictationTemplatePage = compose(
  withUserActivityTracking({ type: ActivityTypeEnum.DICTATION }),
  withDolPremiumStore({}),
  withContextStore({
    dictation: {
      model: DoDictationStore,
      defaultValue: {},
    } as StoreOption<typeof DoDictationStore>,
  }),
  withPronunciationAssessment,
  withAudioInputDevices,
  withControlledVideo,
  withControlledAudioPlayInBackground,
  observer
)(DoDictationTemplatePageBase);
